export default "__VITE_PUBLIC_ASSET__148d089d__"